import { useAtomValue, useSetAtom } from '~shared/lib/atom-state';

import { setVoucherDetailListAtom, voucherDetailListAtom } from './atoms';

export const useParentVoucherDetailList = () => {
  return useAtomValue(voucherDetailListAtom);
};

export const useSetParentVoucherDetailList = () => {
  return useSetAtom(setVoucherDetailListAtom);
};
